import React from "react";
import styles from "./Home.module.css";
import Footer from "../footer/Footer";
import Header from "../header/Header";

const Home = () => {
    return (
        <div className={styles["page_wrapper"]}>
            <Header/>
            <div className={styles["section_wrapper"]}>
                yume collectibles minting soon<br/><br/>
                see the roadmap & the docs for more information
            </div>
            <Footer/>
        </div>
    );
};

export default Home;